export enum OrdersTab {
	open = 'open',
	scheduled = 'scheduled',
	delayed = 'delayed',
}
